var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "sp-panel" },
    [
      _vm.isEditMode
        ? _c(
            "div",
            [
              _c("EditLayout", {
                ref: "editLayout",
                attrs: { "layout-state": _vm.state },
                on: {
                  change: _vm.applyLayoutDraft,
                  "move-shelf": _vm.moveLayoutShelf,
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.isEditMode
        ? [
            _c("LogoUploader", { attrs: { images: _vm.logos } }),
            _vm._v(" "),
            _c("div", { staticClass: "sp-title-row" }, [
              _c("div", { staticClass: "sp-title" }, [
                _c(
                  "svg",
                  {
                    staticClass: "sp-title__icon",
                    attrs: {
                      width: "16",
                      height: "16",
                      viewBox: "0 0 16 16",
                      fill: "none",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M2 4h12M2 8h12M2 12h8",
                        stroke: "currentColor",
                        "stroke-width": "1.5",
                        "stroke-linecap": "round",
                      },
                    }),
                    _vm._v(" "),
                    _c("circle", {
                      attrs: {
                        cx: "13",
                        cy: "12",
                        r: "2",
                        stroke: "currentColor",
                        "stroke-width": "1.3",
                        fill: "none",
                      },
                    }),
                    _vm._v(" "),
                    _c("path", {
                      attrs: {
                        d: "M13 11v2M12 12h2",
                        stroke: "currentColor",
                        "stroke-width": "1",
                        "stroke-linecap": "round",
                      },
                    }),
                  ]
                ),
                _vm._v("\n        Shelf Planogram\n      "),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "sp-icon-btn sp-auto-fill-trigger mr-1",
                    attrs: { title: "Auto Fill" },
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.openAutoFillProductBrowser($event)
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        staticClass: "lucide lucide-wand-sparkles h-3.5 w-3.5",
                        attrs: {
                          xmlns: "http://www.w3.org/2000/svg",
                          width: "24",
                          height: "24",
                          viewBox: "0 0 24 24",
                          fill: "none",
                          stroke: "currentColor",
                          "stroke-width": "2",
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            d: "m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", { attrs: { d: "m14 7 3 3" } }),
                        _c("path", { attrs: { d: "M5 6v4" } }),
                        _c("path", { attrs: { d: "M19 14v4" } }),
                        _c("path", { attrs: { d: "M10 2v2" } }),
                        _c("path", { attrs: { d: "M7 8H3" } }),
                        _c("path", { attrs: { d: "M21 16h-4" } }),
                        _c("path", { attrs: { d: "M11 3H9" } }),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sp-icon-btn",
                    class: { active: _vm.searchActive },
                    attrs: { title: "Search" },
                    on: {
                      click: function ($event) {
                        _vm.searchActive = !_vm.searchActive
                      },
                    },
                  },
                  [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "14",
                          height: "14",
                          viewBox: "0 0 14 14",
                          fill: "none",
                        },
                      },
                      [
                        _c("circle", {
                          attrs: {
                            cx: "5.8",
                            cy: "5.8",
                            r: "4.3",
                            stroke: "currentColor",
                            "stroke-width": "1.4",
                          },
                        }),
                        _vm._v(" "),
                        _c("path", {
                          attrs: {
                            d: "M9 9l3 3",
                            stroke: "currentColor",
                            "stroke-width": "1.4",
                            "stroke-linecap": "round",
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.isAutoFillProductPickerOpen
              ? _c("InlineProductBrowser", {
                  ref: "autoFillProductBrowser",
                  attrs: {
                    variant: "auto-fill",
                    "inline-product-picker-style":
                      _vm.autoFillProductPickerStyle,
                    "selected-instance": _vm.selectedInstance,
                    "has-existing-shelf-products": _vm.hasPlanogramProducts,
                  },
                  on: {
                    close: _vm.onAutoFillProductBrowserClose,
                    "auto-fill": _vm.autoFillShelves,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c("transition", { attrs: { name: "sp-slide" } }, [
              _vm.searchActive
                ? _c("div", { staticClass: "sp-search-wrap" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.searchQuery,
                          expression: "searchQuery",
                        },
                      ],
                      ref: "searchInput",
                      staticClass: "sp-search",
                      attrs: { placeholder: "Search products…" },
                      domProps: { value: _vm.searchQuery },
                      on: {
                        keydown: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k($event.keyCode, "esc", 27, $event.key, [
                              "Esc",
                              "Escape",
                            ])
                          )
                            return null
                          _vm.searchActive = false
                          _vm.searchQuery = ""
                        },
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.searchQuery = $event.target.value
                        },
                      },
                    }),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sp-tabs" },
              _vm._l(_vm.tabs, function (tab) {
                return _c(
                  "button",
                  {
                    key: tab.key,
                    staticClass: "sp-tab",
                    class: { active: _vm.activeFixture === tab.key },
                    on: {
                      click: function ($event) {
                        return _vm.selectTab(tab.key)
                      },
                    },
                  },
                  [
                    _vm._v("\n        " + _vm._s(tab.label) + "\n        "),
                    _c("span", { staticClass: "sp-tab__badge" }, [
                      _vm._v(
                        _vm._s(
                          _vm
                            .shelvesForTab(tab.key)
                            .reduce((s, sh) => s + sh.products.length, 0)
                        ) +
                          "/" +
                          _vm._s(_vm.shelvesForTab(tab.key).length)
                      ),
                    ]),
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sp-shelves" },
              [
                _c(
                  "transition-group",
                  {
                    key: _vm.activeFixture,
                    staticClass: "shelves-container",
                    attrs: { name: "sp-list", tag: "div" },
                  },
                  _vm._l(_vm.filteredShelves, function (shelf) {
                    return _c(
                      "div",
                      {
                        key: shelf.id,
                        staticClass: "sp-shelf",
                        class: { "sp-shelf--active": _vm.isShelfActive(shelf) },
                        attrs: { "data-shelf-id": shelf.id },
                        on: {
                          click: function ($event) {
                            return _vm.selectShelf(shelf)
                          },
                        },
                      },
                      [
                        _c("div", { staticClass: "sp-shelf__head" }, [
                          _c("div", { staticClass: "sp-shelf__meta" }, [
                            _c("span", { staticClass: "sp-shelf__name" }, [
                              _vm._v("Shelf " + _vm._s(shelf.number)),
                            ]),
                            _vm._v(" "),
                            _c("span", { staticClass: "sp-shelf__count" }, [
                              _vm._v(
                                _vm._s(_vm.totalFacings(shelf)) + " facings"
                              ),
                            ]),
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "sp-shelf__actions" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "sp-action-btn",
                                  attrs: { title: "Align left" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.alignShelf(shelf, "left")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 12 12",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1 2v8M3 4h6M3 8h4",
                                          stroke: "currentColor",
                                          "stroke-width": "1.3",
                                          "stroke-linecap": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "sp-action-btn",
                                  attrs: { title: "Align center" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.alignShelf(shelf, "center")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 12 12",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M6 2v8M2 4h8M3 8h6",
                                          stroke: "currentColor",
                                          "stroke-width": "1.3",
                                          "stroke-linecap": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass: "sp-action-btn",
                                  attrs: { title: "Align right" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.alignShelf(shelf, "right")
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "12",
                                        height: "12",
                                        viewBox: "0 0 12 12",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M11 2v8M3 4h6M5 8h4",
                                          stroke: "currentColor",
                                          "stroke-width": "1.3",
                                          "stroke-linecap": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("ShelfSkewPicker", {
                                attrs: {
                                  value: Number(shelf.skew || 0),
                                  "product-spacing": shelf.productSpacing,
                                  "canvas-spacing": _vm.canvasProductSpacing,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.setShelfSkew(shelf, $event)
                                  },
                                  "spacing-change": function ($event) {
                                    return _vm.setShelfProductSpacing(
                                      shelf,
                                      $event
                                    )
                                  },
                                },
                              }),
                              _vm._v(" "),
                              _c("ShelfDepthPicker", {
                                attrs: { value: shelf.depth },
                                on: {
                                  change: function ($event) {
                                    return _vm.setShelfDepth(shelf, $event)
                                  },
                                  "apply-all": function ($event) {
                                    return _vm.applyShelfDepthToAll($event)
                                  },
                                  "reset-all": _vm.resetShelfDepthForAll,
                                },
                              }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "sp-action-btn sp-action-btn--danger",
                                  attrs: { title: "Remove shelf" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      return _vm.removeShelf(shelf.id)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "11",
                                        height: "11",
                                        viewBox: "0 0 11 11",
                                        fill: "none",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        attrs: {
                                          d: "M1.5 1.5l8 8M9.5 1.5l-8 8",
                                          stroke: "currentColor",
                                          "stroke-width": "1.5",
                                          "stroke-linecap": "round",
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "sp-products" },
                          _vm._l(
                            shelf.products,
                            function (product, productIndex) {
                              return _c(
                                "div",
                                {
                                  key: _vm.getShelfProductKey(
                                    product,
                                    productIndex
                                  ),
                                  staticClass: "sp-product",
                                  class: {
                                    "sp-product--highlight":
                                      _vm.searchQuery &&
                                      _vm.productMatches(product),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "sp-product__img" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "d-flex align-items-center justify-content-center zoom-container",
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.openLightboxModal(
                                                product
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "bi bi-zoom-in",
                                          }),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      product.thumbnail
                                        ? _c("img", {
                                            attrs: {
                                              src: product.thumbnail,
                                              alt: product.name,
                                            },
                                            on: {
                                              error: function ($event) {
                                                product.image = null
                                              },
                                            },
                                          })
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "sp-product__img-placeholder",
                                            },
                                            [
                                              _c(
                                                "svg",
                                                {
                                                  attrs: {
                                                    width: "18",
                                                    height: "18",
                                                    viewBox: "0 0 18 18",
                                                    fill: "none",
                                                  },
                                                },
                                                [
                                                  _c("rect", {
                                                    attrs: {
                                                      x: "1",
                                                      y: "1",
                                                      width: "16",
                                                      height: "16",
                                                      rx: "2",
                                                      stroke: "currentColor",
                                                      "stroke-width": "1.3",
                                                      fill: "none",
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("path", {
                                                    attrs: {
                                                      d: "M1 12l4-4 3.5 3.5L13 7l4 5",
                                                      stroke: "currentColor",
                                                      "stroke-width": "1.3",
                                                      "stroke-linecap": "round",
                                                      fill: "none",
                                                    },
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "sp-product__info" },
                                    [
                                      _c(
                                        "p",
                                        { staticClass: "sp-product__name" },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.getShelfProductDisplayName(
                                                  product
                                                )
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "sp-stepper" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "sp-stepper__btn",
                                        attrs: {
                                          disabled:
                                            _vm.getProductFacingCount(
                                              product
                                            ) <= 1,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.decrement(shelf, product)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "10",
                                              height: "10",
                                              viewBox: "0 0 10 10",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M2 5h6",
                                                stroke: "currentColor",
                                                "stroke-width": "1.5",
                                                "stroke-linecap": "round",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "sp-stepper__val" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.getProductFacingCount(product)
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "sp-stepper__btn",
                                        on: {
                                          click: function ($event) {
                                            return _vm.increment(shelf, product)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            attrs: {
                                              width: "10",
                                              height: "10",
                                              viewBox: "0 0 10 10",
                                              fill: "none",
                                            },
                                          },
                                          [
                                            _c("path", {
                                              attrs: {
                                                d: "M5 2v6M2 5h6",
                                                stroke: "currentColor",
                                                "stroke-width": "1.5",
                                                "stroke-linecap": "round",
                                              },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("TiltPicker", {
                                    attrs: { value: Number(product.tilt || 0) },
                                    on: {
                                      change: function ($event) {
                                        return _vm.setProductTilt(
                                          shelf,
                                          product,
                                          $event
                                        )
                                      },
                                      "apply-all": function ($event) {
                                        return _vm.applyProductTiltToAll($event)
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "button",
                                    {
                                      staticClass:
                                        "sp-action-btn sp-action-btn--danger",
                                      attrs: { title: "Remove product" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeProduct(
                                            shelf,
                                            product
                                          )
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            width: "11",
                                            height: "11",
                                            viewBox: "0 0 11 11",
                                            fill: "none",
                                          },
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d: "M1.5 1.5l8 8M9.5 1.5l-8 8",
                                              stroke: "currentColor",
                                              "stroke-width": "1.5",
                                              "stroke-linecap": "round",
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }
                          ),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "sp-add-product",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.addProduct(shelf, $event)
                              },
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "12",
                                  height: "12",
                                  viewBox: "0 0 12 12",
                                  fill: "none",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M6 1v10M1 6h10",
                                    stroke: "currentColor",
                                    "stroke-width": "1.5",
                                    "stroke-linecap": "round",
                                  },
                                }),
                              ]
                            ),
                            _vm._v("\n            Add product\n          "),
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isInlineProductPickerOpen(shelf)
                          ? _c("InlineProductBrowser", {
                              ref: "inlineProductBrowser",
                              refInFor: true,
                              attrs: {
                                "inline-product-picker-style":
                                  _vm.inlineProductPickerStyle,
                                "selected-instance": _vm.selectedInstance,
                              },
                              on: { close: _vm.onInlineProductBrowserClose },
                            })
                          : _vm._e(),
                      ],
                      1
                    )
                  }),
                  0
                ),
                _vm._v(" "),
                _vm.filteredShelves.length === 0 && _vm.searchQuery
                  ? _c("div", { staticClass: "sp-empty" }, [
                      _c(
                        "svg",
                        {
                          staticStyle: { opacity: ".35" },
                          attrs: {
                            width: "32",
                            height: "32",
                            viewBox: "0 0 32 32",
                            fill: "none",
                          },
                        },
                        [
                          _c("circle", {
                            attrs: {
                              cx: "14",
                              cy: "14",
                              r: "9",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                            },
                          }),
                          _vm._v(" "),
                          _c("path", {
                            attrs: {
                              d: "M21 21l7 7",
                              stroke: "currentColor",
                              "stroke-width": "1.5",
                              "stroke-linecap": "round",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v("No products matching "),
                        _c("strong", [
                          _vm._v('"' + _vm._s(_vm.searchQuery) + '"'),
                        ]),
                      ]),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("ProductImageDropdown", {
              ref: "productImageDropdownFields",
              attrs: { "is-tab-active": false, "is-fields-tab": true },
              on: {
                input: function ($event) {
                  return _vm.onChange("productImage", _vm.fileNameIds)
                },
                uploadInput: (fileIds) =>
                  _vm.onChange("productImage", {
                    productIds: fileIds,
                    type: "uploaded_product_image",
                  }),
              },
              model: {
                value: _vm.fileNameIds,
                callback: function ($$v) {
                  _vm.fileNameIds = $$v
                },
                expression: "fileNameIds",
              },
            }),
            _vm._v(" "),
            _c("LightboxModal", { ref: "boxPreview" }),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }